import { documentId, getDocs, query, where } from 'firebase/firestore'
import { toSchoolAccount, type SchoolAccount, type SchoolAccountDoc } from '@common/models/account/school/school-account.modl'
import { refs } from '@common/models/base/firestore-refs'

const SCHOOL_ACCOUNT_IN_QUERY_LIMIT = 30

export async function fetchActiveSchoolAccountsByIds(
  schoolAccountIds: string[],
): Promise<Map<string, SchoolAccount>> {
  const uniqueIds = Array.from(new Set(schoolAccountIds.filter(Boolean)))
  if (uniqueIds.length === 0) return new Map()

  const result = new Map<string, SchoolAccount>()
  for (let i = 0; i < uniqueIds.length; i += SCHOOL_ACCOUNT_IN_QUERY_LIMIT) {
    const chunkIds = uniqueIds.slice(i, i + SCHOOL_ACCOUNT_IN_QUERY_LIMIT)
    const snapshot = await getDocs(
      query(refs.schoolAccounts(), where(documentId(), 'in', chunkIds)),
    )
    snapshot.docs.forEach((docSnap) => {
      const schoolAccount = toSchoolAccount(
        docSnap.id,
        docSnap.data() as SchoolAccountDoc,
        docSnap.ref.path,
      )
      if (!schoolAccount.is_deleted) {
        result.set(schoolAccount.id, schoolAccount)
      }
    })
  }

  return result
}

export async function fetchActiveSchoolAccountById(
  schoolAccountId?: string,
): Promise<SchoolAccount | null> {
  if (!schoolAccountId) return null
  const map = await fetchActiveSchoolAccountsByIds([schoolAccountId])
  return map.get(schoolAccountId) ?? null
}
